<!-- @format -->

<ng-container *transloco="let t">
  @if (this.viewData$ | async; as viewData) {
    <div class="row gy-4">
      @for (studyGroupSetViewData of viewData; track studyGroupSetViewData) {
        <section>
          <div class="col-12">
            <h3
              >{{ t("ENROLMENTS.STUDY_GROUPS.STUDY_GROUP_SET_HEADER") }},
              {{ studyGroupSetViewData.studyGroupSet.name | localizedString }}</h3
            >
          </div>
          @if (
            studyGroupSetViewData.studySubGroupsForLaterPlacement.length > 0 && studyGroupSetViewData.confirmedStudySubGroups.length === 0
          ) {
            <section data-cy="study-sub-groups-for-later-placement">
              <div class="col-12">
                <p>{{ t("COURSE_UNIT_REALISATION.ALLOCATION_RULE.0_0_HAS_GROUPS") }}</p>
              </div>
            </section>
          }
          @if (studyGroupSetViewData.confirmedStudySubGroups.length > 0) {
            <section data-cy="confirmed-study-sub-groups">
              <div class="col-12">
                <h4 class="mt-4">{{ t("ENROLMENTS.STUDY_SUB_GROUPS.STUDENT_SELECTED") }}</h4>
                <ul class="list-unstyled mt-3">
                  @for (studySubGroup of studyGroupSetViewData.confirmedStudySubGroups; track studySubGroup) {
                    <li class="mb-3">
                      <app-study-sub-group-view [studySubGroup]="studySubGroup" [style]="'SELECTED'" />
                    </li>
                  }
                </ul>
              </div>
            </section>
          }
          @if (studyGroupSetViewData.tentativeStudySubGroups.length > 0) {
            <section data-cy="currently-selected-study-sub-groups">
              <div class="col-12">
                <h4 class="mt-4">{{ t("ENROLMENTS.STUDY_SUB_GROUPS.STUDENT_CURRENTLY_SELECTED") }}</h4>
                <ul class="list-unstyled mt-3">
                  @for (studySubGroup of studyGroupSetViewData.tentativeStudySubGroups; track studySubGroup) {
                    <li class="mb-3">
                      <app-study-sub-group-view [studySubGroup]="studySubGroup" [style]="'SELECTED'" />
                    </li>
                  }
                </ul>
              </div>
            </section>
          }
          @if (studyGroupSetViewData.notSelectedStudySubGroups.length > 0) {
            <section data-cy="currently-not-selected-study-sub-groups">
              <div class="col-12">
                <h4 class="mt-4">{{ t("ENROLMENTS.STUDY_SUB_GROUPS.STUDENT_CURRENTLY_NOT_SELECTED") }}</h4>
                <ul class="list-unstyled mt-3">
                  @for (studySubGroup of studyGroupSetViewData.notSelectedStudySubGroups; track studySubGroup) {
                    <li class="mb-3">
                      <app-study-sub-group-view [studySubGroup]="studySubGroup" [style]="'NOT_SELECTED'" />
                    </li>
                  }
                </ul>
              </div>
            </section>
          }
        </section>
      }
    </div>
  }
</ng-container>
